import React from "react";


const InputTextContainer = ({
    value,
    validate,
    isDisabled,
    onChange,
    onFocus,
    onBlur,
    defaultText,
    isReadOnly,
    inputRef,
    onKeyEnter = null,
    onKeyEscape = null,
}) => {
    const handleKeyDown = key => {
        if (onKeyEnter != null && key === 'Enter') {
            onKeyEnter();
        } else if (onKeyEscape != null && key === 'Escape') {
            onKeyEscape();
        }
    }

    const handleFocus = () => {
        if (onFocus != null) {
            onFocus();
        }
    }

    const handleBlur = () => {
        if (onBlur != null) {
            onBlur();
        }
    }

    return (
        <div className="input-container">
            {isDisabled
                ? <input
                    className="input-dummy-disabled"
                    type="text"
                    autoComplete="off"
                />
                : isReadOnly
                    ? <input
                        className="input-dummy-readonly"
                        type="text"
                        autoComplete="off"
                        value={value}
                        placeholder={defaultText}
                        readOnly
                    />
                    : <input    //  !isDisabled && !isReadOnly
                        className="input"
                        type="text"
                        spellCheck="false"
                        autoComplete="off"
                        value={value}
                        placeholder={defaultText}
                        required={validate}
                        onChange={(event) => onChange(event.target.value)}
                        onKeyDown={(event) => handleKeyDown(event.key)}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        ref={inputRef}
                    />
            }
        </div>
    );
}


export default InputTextContainer;